import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AddShowsModalComponent } from '../../_modals/add-shows-modal/add-shows-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { PartnerGroup } from 'src/app/shared/models/partner-group';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { PartnerGroupToolTipModalComponent } from '../../_modals/partner-group-tool-tip-modal/partner-group-tool-tip-modal.component';

@Component({
  selector: 'app-pro-partner-show-header',
  templateUrl: './pro-partner-show-header.component.html',
  styleUrls: ['./pro-partner-show-header.component.scss'],
  // encapsulation: ViewEncapsulation.ShadowDom
})
export class ProPartnerShowHeaderComponent implements OnInit {

  partnerGroups: PartnerGroup[];

  partnerGroupsBtnDisplay: any[] = [];

  constructor(public dialog: MatDialog, private partnerService: PartnerService) { }

  ngOnInit() {

    //track partner groups for selected partner
    this.partnerService.partnerGroups$.subscribe((x) => {
      this.partnerGroups = x;

      //reset
      this.partnerGroupsBtnDisplay = [];

      //build display for group buttons
      this.partnerGroups.forEach(group => {

        let displayName = '';

        group.members.forEach(member => {
          displayName += member.partner.name + ' + ';
        });

        if (displayName.endsWith(' + ')) {
          //trim off last '+'
          displayName = displayName.slice(0, -3);
        }


        let displayValues = {
          id: group.id,
          name: displayName
        }

        this.partnerGroupsBtnDisplay.push(displayValues);
      })
    });
  }

  addShow() {
    const dialogRef = this.dialog.open(AddShowsModalComponent, {
      // width: '800px',
      // height: '400px',
      // data: { anyDataYouWantToPass: 'example' } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }


  showPartnerGroupToolTip( buttonElement: HTMLElement, groupId: number): void {

    let partnerGroup = this.partnerGroups.find(item => item.id === groupId);

    const rect = buttonElement.getBoundingClientRect();
    const buttonCenterX = rect.left; //point to the center of the button
    const buttonCenterY = rect.top + rect.height; //point to the bottom of the button

    const dialogRef = this.dialog.open(PartnerGroupToolTipModalComponent, {
      // data: { top: event.clientY, left: event.clientX }, //uses 'event: MouseEvent' argument
      // position: { top: `${event.clientY}px`, left: `${event.clientX}px` } //uses 'event: MouseEvent' argument
      data: { top: buttonCenterY, left: buttonCenterX, partnerGroup: partnerGroup },
      position: { top: `${buttonCenterY}px`, left: `${buttonCenterX}px` }
    });
  }


}
